module.exports = __webpack_public_path__ + "img/posture.2ec56c77.jpg";